module.exports = __webpack_public_path__ + "static/hero-pc-c4561dd8532e1c17ec1ae405efea1127.svg";